export enum ResponseStateEnum {
    Positive = 1,
    Negative = 2,
    Netural = 3
  }

export enum SelectableResponseStateEnum{
  Selected = 1,
  Enabled = 2,
  Disabled = 3
}

export enum DiscoveryQuestionTypeEnum {
  Standard = 1,
  TailResolution = 2,
  MotivationGap = 3
}